export default class ParameterMissingError extends Error {
  constructor (paramName) {
    super(`Get Parameter [${paramName}] is missing.`)
  }
}
